import React from 'react';

import { CloseOutlined } from '@mui/icons-material';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
} from '@mui/material';

import Button from 'src/components/Button';
import Spacer from 'src/components/Spacer';

interface ConfirmationModalProps {
    isOpen: boolean;
    title?: string | React.ReactNode;
    message: string | React.ReactNode;
    onCancel?: () => void;
    onConfirm?: () => void;
    confirmText?: string;
    cancelText?: string;
    hideCancelButton?: boolean;
    hideConfirmButton?: boolean;
    cancelBtnVariant?: string;
    justifyButtonContent?: string;
    dialogActionMarginTop?: string;
    modalWidth?: string;
    name?: string;
    confirmBtnVariant?: 'main' | 'npi-primary' | 'outlined-black';
    confirmBtnWdith?: string;
    loading?: boolean;
}

const ConfirmationModal = ({
    isOpen,
    title,
    message,
    onCancel,
    onConfirm,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    justifyButtonContent = 'center',
    cancelBtnVariant = 'outlined-black',
    dialogActionMarginTop = '0px',
    modalWidth,
    hideCancelButton,
    name = 'confirmation-modal',
    hideConfirmButton,
    confirmBtnWdith = '100%',
    confirmBtnVariant = 'main',
    loading,
}: ConfirmationModalProps) => {
    return (
        <Dialog
            open={isOpen}
            maxWidth="xs"
            aria-labelledby="confirmation-modal"
            sx={{
                '& .MuiPaper-root': {
                    margin: '0px',
                    padding: '0px',
                    borderRadius: '16px',
                    width: modalWidth,
                },
                '& .MuiPaper-root.MuiDialog-paper': {
                    maxWidth: modalWidth ? 'none' : '444px',
                },
            }}
        >
            <Stack
                flexDirection="row"
                bgcolor="#ff9800"
                justifyContent="space-between"
                alignItems="center"
                pr={2}
            >
                <DialogTitle color="white">{title}</DialogTitle>
                <IconButton
                    onClick={onCancel}
                    sx={{
                        width: '20px',
                        height: '20px',
                        padding: 1.8,
                        bgcolor: 'white',
                        color: '#ff9800',
                        border: '2px #ff9800 solid',
                        ':hover': {
                            background: 'white',
                        },
                    }}
                >
                    <CloseOutlined />
                </IconButton>
            </Stack>
            <DialogContent sx={{ whiteSpace: 'pre-wrap' }}>{message}</DialogContent>
            {(() => {
                if (
                    (!hideConfirmButton && !hideCancelButton) ||
                    !hideCancelButton ||
                    onConfirm ||
                    (!hideCancelButton && onConfirm)
                ) {
                    return (
                        <Stack width="100%" p={2}>
                            <DialogActions
                                sx={{
                                    justifyContent: justifyButtonContent,
                                    alignItems: 'center',
                                    marginTop: dialogActionMarginTop,
                                }}
                            >
                                {!hideCancelButton && (
                                    <Button
                                        dataTestId={`${name}-cancel-button`}
                                        sx={{ width: '100%' }}
                                        variant={cancelBtnVariant}
                                        onClick={onCancel}
                                    >
                                        {cancelText}
                                    </Button>
                                )}
                                <Spacer padding={0.1} />
                                {onConfirm && !hideConfirmButton ? (
                                    <Button
                                        dataTestId={`${name}-confirm-button`}
                                        sx={{ width: confirmBtnWdith }}
                                        variant={confirmBtnVariant}
                                        onClick={onConfirm}
                                        loading={loading}
                                    >
                                        {confirmText}
                                    </Button>
                                ) : null}
                                {justifyButtonContent === 'end' ? <Spacer padding={0.1} /> : null}
                            </DialogActions>
                            <Spacer padding={1.5} />
                        </Stack>
                    );
                }
                return null;
            })()}
        </Dialog>
    );
};

export default ConfirmationModal;
